export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5404.a3482da3.jpg";